import React from 'react';
import Icon from '../Icon';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const NavbarItemContainer = styled.div`
  a {
    text-decoration: none !important;
  }

  .smallContainer {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    ${(props) => props.isTablet && 'height: 65px'}
  }

  .shortTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 11px;
    color: #2b3d54;
    text-transform: uppercase;
    margin-top: 5px;
  }

  .navbarItemIcon {
    position: relative;
    color: black;
  }

  .smallNotificationContainer {
    position: absolute;
    top: -3px;
    right: -6px;
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
  }

  ${(props) =>
    !props.isTablet &&
    `.navbarItem:hover {
    .smallContainer {
      background-color: #f5f5f5;
      border-right: 3px solid #e25d34;
    }

    .navbarItemIcon {
      color: #e25d34;
    }

    .shortTitle,
    .navbarItemTitle {
      color:#e25d34;
      opacity: 1;
    }

    .expandedContainer {
      border-right: 3px solid #e25d34;
    }

    .iconDeploy{
      margin-right:30px;
    }
  }`}

  .activeNavbarItem {
    .smallContainer {
      background-color: ${(props) => props.theme.colors['white-two']};
      border-right: 3px solid ${(props) => props.theme.colors['terra-cotta']};
    }

    .navbarItemIcon {
      color: ${(props) => props.theme.colors['terra-cotta']};
    }

    .shortTitle,
    .navbarItemTitle {
      color: ${(props) => props.theme.colors['terra-cotta']};
      opacity: 1;
    }

    .expandedContainer {
      border-right: 3px solid ${(props) => props.theme.colors['terra-cotta']};
    }

    .iconDeploy {
      margin-right: 30px;
    }
  }

  .expandedContainer {
    height: 70px;
    display: flex;
    flex-direction: center;
    align-items: center;
    z-index: 5px;
    position: relative;
    box-shadow: ${(props) =>
      !props.deploy ? 'none' : '0px 5px 8px rgba(50,50,50,0.1)'};
  }

  .expandedNavbarItemIcon {
    margin-left: 33px;
    margin-right: 20px;
  }

  .navbarItemTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    animation-duration: 2s;
    animation-name: appear;
    color: ${(props) => props.theme.colors['dark']};
    text-transform: uppercase;
  }

  .notificationContainer {
    margin-left: auto;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .notificationContainer p {
    color: white;
    font-size: 9px;
    line-height: 20px;
    vertical-align: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .iconDeploy {
    font-size: 10px;
    margin-left: auto;
    margin-right: 33px;
    color: rgb(31, 43, 55);
    padding: 5px;
  }

  .navbarSubMenuContainer {
    z-index: 4;
    background-color: ${(props) => props.theme.colors['white-two']};
    display: flex;
    flex-direction: column;
    padding-left: 55px;
    padding-top: 27px;
    padding-bottom: 27px;
  }

  .navbarSubMenuItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.oswald_light};
    font-size: 14px;
    color: #1e3647;
  }

  ${(props) =>
    !props.isTablet &&
    `.navbarSubMenuItem:hover {
    color: #e25d34;
    cursor: pointer;
  }
`}

  .navbarSubMenuItemActive {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .navbarSubMenuItem:not(:last-child) {
    margin-bottom: 9px;
  }

  .navbarSubMenuItemIcon {
    margin-right: 10px;
  }
`;

const renderSubMenu = (subMenu, isTablet, retractMenu) => (
  <div className="navbarSubMenuContainer">
    {subMenu
      .filter((item) => item)
      .map((menu) =>
        menu.isExternal && menu.enable ? (
          <a
            href={menu.route}
            target="_blank"
            key={JSON.stringify(menu)}
            className="navbarSubMenuItem"
            rel="noreferrer"
          >
            <div className="navbarSubMenuItemIcon">
              <Icon icon="arrowRight" />
            </div>
            {menu.title}
          </a>
        ) : (
          menu.enable && (
            <NavLink
              className="navbarSubMenuItem"
              activeClassName="navbarSubMenuItemActive"
              to={menu.route || '/'}
              key={JSON.stringify(menu)}
              onClick={isTablet ? () => retractMenu() : undefined}
            >
              <div className="navbarSubMenuItemIcon">
                <Icon icon="arrowRight" />
              </div>

              {menu.title}
            </NavLink>
          )
        )
      )}
  </div>
);

const renderExpendedItem = (
  icon,
  title,
  subMenu,
  notification,
  onDeploy,
  deployed
) => (
  <div className="expandedContainer">
    <div className="navbarItemIcon expandedNavbarItemIcon">
      <Icon icon={icon} />
    </div>
    <h3 className="navbarItemTitle">{title}</h3>
    {renderSubMenuIcon(subMenu, notification, deployed, title, onDeploy)}
  </div>
);

const renderSubMenuIcon = (subMenu, notification, deployed, title, onDeploy) =>
  subMenu ? (
    <div
      className="iconDeploy"
      onClick={(event) => {
        event.preventDefault();
        onDeploy(title);
      }}
    >
      <Icon icon={deployed ? 'arrowTop' : 'arrowBottom'} />
    </div>
  ) : (
    notification && (
      <span className="notificationContainer">
        <p>{notification}</p>
      </span>
    )
  );

const NavbarItem = ({
  icon,
  title,
  isTablet,
  shortTitle,
  route,
  subMenu,
  expanded,
  notification,
  retractMenu,
  onDeploy,
  deployed,
  onMouseEnter
}) => (
  <NavbarItemContainer
    deploy={deployed}
    isTablet={isTablet}
    onMouseEnter={(event) => (!isTablet ? onMouseEnter(event) : undefined)}
  >
    <NavLink
      activeClassName="activeNavbarItem"
      className="navbarItem"
      to={route || '/'}
      onClick={subMenu ? () => onDeploy(title) : undefined}
    >
      {expanded ? (
        renderExpendedItem(
          icon,
          title,
          subMenu,
          notification,
          onDeploy,
          deployed
        )
      ) : (
        <div className="smallContainer">
          <div className="navbarItemIcon">
            <Icon icon={icon} />
            {notification && <div className="smallNotificationContainer" />}
          </div>
          <h3 className="shortTitle">{shortTitle}</h3>
        </div>
      )}
    </NavLink>
    {subMenu &&
      expanded &&
      deployed &&
      renderSubMenu(subMenu, isTablet, retractMenu)}
  </NavbarItemContainer>
);

export default NavbarItem;
